import React, { useEffect, useState } from 'react';
import { PasswordGate } from './components/PasswordGate';
import { AudioLibrary } from './components/AudioLibrary';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  useEffect(() => {
    // Check session storage on mount
    const auth = sessionStorage.getItem('gemma_auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, []);
  const handleSuccess = () => {
    sessionStorage.setItem('gemma_auth', 'true');
    setIsAuthenticated(true);
  };
  // Show nothing while checking session storage to prevent flash
  if (isAuthenticated === null) {
    return <div className="min-h-screen bg-gemma-cream" data-id="element-0" />;
  }
  return <div className="antialiased selection:bg-gemma-accent/20 selection:text-gemma-charcoal" data-id="element-1">
      {isAuthenticated ? <AudioLibrary data-id="element-2" /> : <PasswordGate onSuccess={handleSuccess} data-id="element-3" />}
    </div>;
}